import ApiService from "../../utils/ApiService";

export async function getInventoryFinalReport(params, token) {
  try {
    const { payload } = await ApiService.GET_INVENTORY_FINAL_REPORT(params, token);

    const numericData = Object.fromEntries(Object.entries(payload.record).map(([key, value]) => [key, Number(value)]));
    return {
      success: true,
      record: numericData,
    };
  } catch (error) {
    console.log("---------------error---------------------");

    return {
      success: false,
      message: error.message,
    };
  }
}

export async function getDownloadableData(params, token) {
    return ApiService.GET_DOWNLOADABLE_FINAL_REPORT(params, token)
      .then((res) => {
        if (res.status == 200) {
          return {
            loading: false,
            data: res.data,
          };
        }
      })
      .catch((err) => {
        return {
          loading: false,
          message: err.message || "An error has been occured.",
          data: null,
        };
      });
}
